import { schema } from 'normalizr'

const station = new schema.Entity('stations')

export default station
